import React, { useContext } from 'react';
import { BrokenCard } from 'src/assets/images';
import ButtonPrimary from 'src/containers/self-service/broker-journey/component/button-primary/button-primary';
import { HeadingLayout } from '../../layout';
import { HeadingOne } from '../heading-one/heading-one';
import { HeadingTwo } from '../heading-two/heading-two';
import ButtonSecondary from 'src/containers/self-service/broker-journey/component/button-secondary/button-secondary';
import { publicSiteUrl, RowFill } from 'src/common';
import { ApplicationContext } from 'src/features/order';
import { ApplicationActionType } from '../../types';
import { useAsyncDispatch } from 'src/features/order/hooks/use-async-dispatch';
import { useWizardEffect } from '../../hooks';
import { killApplication } from '../../reducers/application/application-reducer-helpers';
import './payment-timeout.scss';

interface Props {
  subStatus?: string;
  onClick: () => void;
  maxNumberOfTries?: boolean;
}

export const PaymentTimeout: React.FC<Props> = ({
  subStatus = '',
  onClick,
  maxNumberOfTries = false,
}) => {
  const { application, dispatch, salesforceService, catalogue, dpoTealiumService } =
    useContext(ApplicationContext);
  const dispatchAsync = useAsyncDispatch(application, dispatch);

  const { setLoadingOverlayVisible } = useWizardEffect(() => ({}), []);

  const cancelApplication = async () => {
    setLoadingOverlayVisible(true);
    const updatedApp = await dispatchAsync({
      type: ApplicationActionType.KILL_APPLICATION,
    });

    await salesforceService.saveApplication(killApplication(updatedApp, catalogue), true);
    setLoadingOverlayVisible(false);

    window.location.href = publicSiteUrl;
  };

  React.useEffect(() => {
    dpoTealiumService?.paymentFailureLanding(
      application.remotePayment?.responseMessage || '',
      application.remotePayment?.responseCode || '',
    );
  }, []);

  return (
    <div className="payment-status">
      <img className="status-logo" src={BrokenCard} />
      <HeadingLayout
        renderMainHeading={() => <HeadingOne>{'Payment Failed'}</HeadingOne>}
        renderSubHeading={() => (
          <HeadingTwo>
            {subStatus ? subStatus : maxNumberOfTries ? 'Max number of tries' : 'Gateway timeout'}
          </HeadingTwo>
        )}
      />

      <RowFill flexWrap="wrap-reverse" gap="1rem" justifyContent="center">
        <ButtonSecondary onClick={cancelApplication} className="status-button">
          Cancel Application
        </ButtonSecondary>

        <ButtonPrimary onClick={onClick} className="status-button">
          {maxNumberOfTries ? 'Exit' : 'Retry'}
        </ButtonPrimary>
      </RowFill>
    </div>
  );
};
